// extracted by mini-css-extract-plugin
module.exports = {"LawTag":"LawTag_LawTag__316DG"};